import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { styles, colors } = theme.busbud;
  const border_style = `${styles.borderWidth.sm} solid ${colors.border.primary.opaque}`;

  return {
    container: {
      width: "100%"
    },
    header: {
      borderTop: border_style,
      ["&:last-of-type, &:first-of-type"]: {
        borderTop: "none"
      }
    }
  };
});
